export const useTheme = () => {
  return useState<'light' | 'dark'>('global-theme', () => 'light')
}
